<template>
  <div class="booking-preorder-share">
    <HUITextInput
      class="booking-preorder-share__link"
      @copy="handleShareUrlCopy"
      v-model="shareUrl"
      placeholder="Send linket til de andre gæster"
      copy
    />
    <HUILoadingView class="booking-preorder-share__loader" v-if="!orderLines" />
    <p v-else class="booking-preorder-share__explainer">
      <template v-if="orderLineNames">{{ orderLineNames }}</template>
      <template v-else>Ingen andre har valgt hvad de vil have endnu</template>
    </p>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { HUITextInput, HUILoadingView } from '@/halifax-ui'
import joinNames from '@/utils/joinNames'

export default {
  components: {
    HUITextInput,
    HUILoadingView
  },
  props: {
    orderLines: {
      type: Array
    }
  },
  data() {
    return {
      shareUrl: location.href.substring(location.href.indexOf('://') + 3, location.href.length)
    }
  },
  computed: {
    ...mapState('user', {
      userClientToken: 'client_token'
    }),
    orderLineNamesData() {
      const tokens = []

      return this.orderLines.reduce(
        (acc, orderLine) => {
          const name = orderLine.customer_name
          const token = orderLine.customer_token
          const processedToken = token && tokens.includes(token)

          // We are only interested in other users, so don't act if the user added this orderLine
          if (token === this.userClientToken) {
            return acc
          }
          if (!processedToken) {
            if (name && !acc['named'].includes(name)) {
              acc['named'].push(name)
            } else {
              acc['unnamed'] += 1
            }
            tokens.push(token)
          }
          return acc
        },
        { named: [], unnamed: 0 }
      )
    },
    orderLineNames() {
      const { named, unnamed } = this.orderLineNamesData
      const totalOthers = named.length + unnamed

      if (totalOthers === 0) {
        return 'Ingen andre har valgt hvad de vil spise endnu'
      } else {
        const names = named.slice(0)
        const heHerThem = totalOthers === 1 ? 'han/hun' : 'de'

        if (unnamed > 0) {
          names.push(`${unnamed} ${unnamed === 1 ? 'anden' : 'andre'}`)
        }

        return `${joinNames(names)} har allerede valgt hvad ${heHerThem} vil spise`
      }
    }
  },
  methods: {
    handleShareUrlCopy() {
      this.$store.dispatch('toast/SUCCESS', 'Linket blev kopieret til udklipsholderen.')
    }
  }
}
</script>

<style lang="scss">
@import '~@/halifax-ui/src/scss/framework';
@import '~@/scss/variables';

.booking-preorder-share {
  &__link {
  }
  &__loader {
    font-size: 1.3rem;
    margin-top: 9px;
  }
  &__explainer {
    font-weight: 600;
    text-align: center;
    margin-top: 11px;
    font-size: 1.3rem;
    font-style: italic;
    color: hsla(0, 0%, 50%, 0.6);
  }
}
</style>
